import { NavLink } from "react-router";
import logoImage from "../../assets/logo.png";
import { LogOut } from "lucide-react";
import { useLogout } from "../../hooks/useLogout";

const Header = () => {
  const handleLogout = useLogout();

  return (
    <header className="bg-white text-[#0B1120] py-4 px-6 relative z-40 flex border-b border-gray-100 shadow-sm">
      <nav className="flex items-center gap-8 w-full max-w-[1400px] mx-auto">
        <NavLink to={"/app"}>
          <h1 className="text-lg font-semibold flex items-center tracking-tight">
            <img src={logoImage} alt="NeuroHubs Logo" className="w-8 h-8 object-contain" />
            <span className="ml-2 text-blue-600">neurohubs</span>
          </h1>
        </NavLink>

        <NavLink
          to={"/app"}
          className={({ isActive }) =>
            `text-sm font-medium transition-all duration-300 ${isActive ? "text-[#0B1120]" : "text-gray-400 hover:text-[#0B1120]"}`
          }
          end
        >
          Patients
        </NavLink>
        <NavLink
          to={"/configuration"}
          className={({ isActive }) =>
            `text-sm font-medium transition-all duration-300 ${isActive ? "text-[#0B1120]" : "text-gray-400 hover:text-[#0B1120]"}`
          }
        >
          Diagnostics Center
        </NavLink>
        <button
          onClick={handleLogout}
          className="ml-auto text-gray-400 hover:text-[#0B1120] transition-all duration-300 hover:cursor-pointer"
          title="Logout"
        >
          <LogOut className="w-5 h-5" />
        </button>
      </nav>
    </header>
  );
};

export default Header;
